import Home from "./components/home/Home";
import "./App.css";
import JoinRoom from "./components/join-room/JoinRoom";
import { HashRouter as Router } from "react-router-dom";
import { Route, Routes } from "react-router-dom";
import SessionJoinDialog from "./components/sessionJoinDialog/SessionJoinDialog";
import { RecoilRoot } from "recoil";
import Header from "./components/header/Header";
import Feedback from "./components/feedback/Feedback";
import { useEffect } from "react";

const App: React.FC = () => {

  useEffect(() => {
    document.title = "Huddle";
  }, []);
  
  return (
    <RecoilRoot>
      <Router>
        <Header />

        <Routes>
          <Route path="/" Component={Home} />
          <Route path="/session-join/:token" Component={SessionJoinDialog} />
          <Route path="/session" Component={JoinRoom} />
          <Route path="/feedback" Component={Feedback} />
        </Routes>
      </Router>
    </RecoilRoot>
  );
};

export default App;
